import React from 'react';
import { graphql } from 'gatsby';
import { SEO } from '../views/SEO';

import Layout from '../layout/Layout';
import PortfolioRoot from '../views/Portfolio/PortfolioRoot';

const PortfolioPage = ({ data }) => (
	<Layout>
		<SEO
			title={data.contentfulPageMetaData.pageTitle}
			metaDescription={data.contentfulPageMetaData.metaDescription}
			slug={'/projects'}
		/>
		<PortfolioRoot />
	</Layout>
);

export default PortfolioPage;

export const query = graphql`
	query PortfolioPage {
		contentfulPageMetaData(title: { eq: "portfolio" }) {
			title
			pageTitle
			metaDescription
		}
	}
`;
